import {defineStore} from 'pinia';
import {ModuleProgress} from './../moduleConst';

const state = {
  // Tiến trình của các tác vụ đang chạy dạng {key, currentValue, maxValue, isCompleted}
  allProgress: [],
};

const actions = { 
  /**
   * Gán 1 tiến trình vào danh sách
   * @param {*} progress 
   */
  setProgress(progress) {
    if(!this.allProgress) {
      this.allProgress = [];
    }

    this.allProgress =  this.allProgress.filter(p => p.key !== progress.key);
    this.allProgress.push(progress);
  },
  /**
   * Lấy tiến trình theo key
   * @param {*} key 
   * @returns 
   */
  getProgress(key) {
    if(!this.allProgress || this.allProgress.length === 0) {
      return null;
    }

    return this.allProgress.find(p => p.key === key);
  },
  removeProgress(key) {
    if(!this.allProgress || this.allProgress.length === 0) {
      return;
    }

    this.allProgress = this.allProgress.filter(p => p.key !== key);
  }
}

const getters = {
}

export const useProgressStore = defineStore(ModuleProgress, {
  state: () => state,
  actions,
  getters: getters,
  persist: {
    storage: localStorage,
    beforeRestore: (ctx, action) => {},
    afterRestore: (ctx, action) => {},
    debug: true,
  },
});